import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ModalNotGoodOutpout.module.scss';
import { AiOutlineClose } from 'react-icons/ai';
import { BsExclamationTriangleFill } from 'react-icons/bs';

const ModalNotGoodOupout = ({ setOverlay, setModalNotGoodOutpout }) => {
  const { t } = useTranslation();
  const handleClose = () => {
    setOverlay(false);
    setModalNotGoodOutpout(false);
  };

  return (
    <>
      <div className={styles.wrapperModal} onClick={handleClose} />
      <div className={styles.containerModal}>
        <button className={`${styles.closeBtn} has-tooltip`} onClick={handleClose} aria-label={t("common.close")}>
          <AiOutlineClose />
        </button>

        <div className={styles.warningIcon}>
          <BsExclamationTriangleFill />
        </div>

        <h4 className={styles.modalTitle}>{t("calibration_data.invalid_file")}</h4>
        <p className={styles.modalText}>
          {t("calibration_data.invalid_file_text")}
        </p>

        <div className={styles.actions}>
          <button className={styles.btnClose} onClick={handleClose}>{t("common.close")}</button>
        </div>
      </div>
    </>
  );
};

export default ModalNotGoodOupout;